// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1CX_S","productName":"Table_productName__1wFi0"};